import React from 'react';
import { StatusBar } from 'react-native';
import { SafeAreaProvider } from 'react-native-safe-area-context';
import { GestureHandlerRootView } from 'react-native-gesture-handler';
import FlashMessage from 'react-native-flash-message';

import { AppNavigator } from './src/navigation';
import { useAuth } from './src/hooks/useAuth';
import { Colors } from './src/theme';
import { I18nProvider } from './src/i18n';
import { LocationEngineProvider } from './src/context/LocationEngineProvider';
import { usePresenceHeartbeat } from './src/hooks/usePresenceHeartbeat';
import { AppShell } from './src/AppShell';

export default function App() {
  const {
    user,
    loading,
    isSigningIn,
    emailVerified,
    isEmailPasswordAccount,
    hasTrustedLinkedProvider,
    signInWithEmail,
    completePartnerPasswordSetup,
    resetPassword,
    signInWithGoogle,
    signInWithApple,
    signOut,
    reloadUser,
    resendVerificationEmail,
  } =
    useAuth();

  usePresenceHeartbeat();

  return (
    <AppShell>
      <GestureHandlerRootView style={{ flex: 1 }}>
        <SafeAreaProvider>
          <I18nProvider>
            <StatusBar barStyle="light-content" backgroundColor={Colors.bg} />
            <LocationEngineProvider>
              <AppNavigator
                user={user}
                loading={loading}
                isSigningIn={isSigningIn}
                emailVerified={emailVerified}
                isEmailPasswordAccount={isEmailPasswordAccount}
                hasTrustedLinkedProvider={hasTrustedLinkedProvider}
                onEmailSignIn={signInWithEmail}
                onCompletePartnerPasswordSetup={completePartnerPasswordSetup}
                onPasswordReset={resetPassword}
                onGoogleSignIn={signInWithGoogle}
                onAppleSignIn={signInWithApple}
                onSignOut={signOut}
                onResendVerificationEmail={resendVerificationEmail}
                onCheckEmailVerification={reloadUser}
              />
            </LocationEngineProvider>
          </I18nProvider>
          <FlashMessage position="top" />
        </SafeAreaProvider>
      </GestureHandlerRootView>
    </AppShell>
  );
}
